import { combineReducers } from "redux";
import { AlertDialogReducer } from "./components/AlertDialogReducer";
import { VideoDialogReducer } from "./components/VideoDialogReducer";
import { BackDropReducer } from "./components/BackDropReducer";
import { InfoReducer } from "./components/InforReducer";
import { LoginReducer } from "./LoginReducer";
import { VendorCreateReducer } from "./vendor/VendorCreateReducer";
import { VendorBlockDataReducer } from "./vendor/VendorBlockDataReducer";
import { VendorDetailReducer } from "./vendor/VendorDetailReducer";
import { CallOverVerificationReducer } from "./vendor/CallOverVerificationReducer";
import { VendorDashboradFilterReducer } from "./vendor/VendorDashboradFilterReducer";
import { VendorSearchDataReducer } from "./vendor/VendorSearchDataReducer";

const rootReducer = combineReducers({
  loginDetails: LoginReducer,
  vendorCreateDetails: VendorCreateReducer,
  vendorDetails: VendorDetailReducer,
  infoDisplayDetails: InfoReducer,
  backDropDetails: BackDropReducer,
  alertDialogDetails: AlertDialogReducer,
  videoDialogDetails: VideoDialogReducer,
  callOverVerifications:CallOverVerificationReducer,
  vendorDashboradFilter:VendorDashboradFilterReducer,
  vendorBlockData : VendorBlockDataReducer,
  vendorSearchData: VendorSearchDataReducer

});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
